/**
 * API utility functions
 */

export function getApiUrl(path?: string): string {
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:7071/api';
  return path ? `${baseUrl}/${path}` : baseUrl;
}
